//@ts-nocheck

import React, { ReactElement, useEffect, useState } from 'react';
import OriginalVimeo from '@u-wave/react-vimeo';
import styled from 'styled-components';
import { Player as PlayerProps } from '@vimeo/player';

import { VideoPlayerProps } from 'features/player';

import { ResponsiveSizes } from '../../types';

const Vimeo = styled(OriginalVimeo)<{
  customWidth: ResponsiveSizes;
  customHeight: ResponsiveSizes;
  customMaxWidth: ResponsiveSizes;
  customMaxHeight: ResponsiveSizes;
}>`
  display: flex;
  flex-grow: 1;
  background: black;
  align-items: center;
  justify-content: center;

  ${({ customWidth, theme: { mediaQueries } }) => {
    if (typeof customWidth === 'object') {
      let response = '';

      if (customWidth.m) {
        response = `
          ${response}

          ${mediaQueries.mobile} {
            width: ${typeof customWidth.m === 'number' ? `${customWidth.m}px` : customWidth.m};
          }
        `;
      }

      if (customWidth.t) {
        response = `
          ${response}

          ${mediaQueries.tablet} {
            width: ${typeof customWidth.t === 'number' ? `${customWidth.t}px` : customWidth.t};
          }
        `;
      }

      if (customWidth.d) {
        response = `
          ${response}

          ${mediaQueries.desktop} {
            width: ${typeof customWidth.d === 'number' ? `${customWidth.d}px` : customWidth.d};
          }
        `;
      }

      return response;
    } else {
      return `
        width: ${typeof customWidth === 'number' ? `${customWidth}px` : customWidth};
      `;
    }
  }};

  ${({ customHeight, theme: { mediaQueries } }) => {
    if (typeof customHeight === 'object') {
      let response = '';

      if (customHeight.m) {
        response = `
          ${response}

          ${mediaQueries.mobile} {
            height: ${typeof customHeight.m === 'number' ? `${customHeight.m}px` : customHeight.m};
          }
        `;
      }

      if (customHeight.t) {
        response = `
          ${response}

          ${mediaQueries.tablet} {
            height: ${typeof customHeight.t === 'number' ? `${customHeight.t}px` : customHeight.t};
          }
        `;
      }

      if (customHeight.d) {
        response = `
          ${response}

          ${mediaQueries.desktop} {
            height: ${typeof customHeight.d === 'number' ? `${customHeight.d}px` : customHeight.d};
          }
        `;
      }

      return response;
    } else {
      return `
        height: ${typeof customHeight === 'number' ? `${customHeight}px` : customHeight};
      `;
    }
  }};

  ${({ customMaxWidth, theme: { mediaQueries } }) => {
    if (typeof customMaxWidth === 'object') {
      let response = '';

      if (customMaxWidth.m) {
        response = `
          ${response}

          ${mediaQueries.mobile} {
            max-width: ${typeof customMaxWidth.m === 'number' ? `${customMaxWidth.m}px` : customMaxWidth.m};
          }
        `;
      }

      if (customMaxWidth.t) {
        response = `
          ${response}

          ${mediaQueries.tablet} {
            max-width: ${typeof customMaxWidth.t === 'number' ? `${customMaxWidth.t}px` : customMaxWidth.t};
          }
        `;
      }

      if (customMaxWidth.d) {
        response = `
          ${response}

          ${mediaQueries.desktop} {
            max-width: ${typeof customMaxWidth.d === 'number' ? `${customMaxWidth.d}px` : customMaxWidth.d};
          }
        `;
      }

      return response;
    } else {
      return `
        max-width: ${typeof customMaxWidth === 'number' ? `${customMaxWidth}px` : customMaxWidth};
      `;
    }
  }};

  ${({ customMaxHeight, theme: { mediaQueries } }) => {
    if (typeof customMaxHeight === 'object') {
      let response = '';

      if (customMaxHeight.m) {
        response = `
          ${response}

          ${mediaQueries.mobile} {
            max-height: ${typeof customMaxHeight.m === 'number' ? `${customMaxHeight.m}px` : customMaxHeight.m};
          }
        `;
      }

      if (customMaxHeight.t) {
        response = `
          ${response}

          ${mediaQueries.tablet} {
            max-height: ${typeof customMaxHeight.t === 'number' ? `${customMaxHeight.t}px` : customMaxHeight.t};
          }
        `;
      }

      if (customMaxHeight.d) {
        response = `
          ${response}

          ${mediaQueries.desktop} {
            max-height: ${typeof customMaxHeight.d === 'number' ? `${customMaxHeight.d}px` : customMaxHeight.d};
          }
        `;
      }

      return response;
    } else {
      return `
        max-height: ${typeof customMaxHeight === 'number' ? `${customMaxHeight}px` : customMaxHeight};
      `;
    }
  }};

  > iframe {
    width: 100%;
    height: 100%;
  }
`;

const VimeoPlayer = ({
  onTimeUpdate,
  onEnd,
  startInSecond,
  externalVideoProviderIdOrUrl,

  width = '100%',
  height = 'auto',
  maxWidth = 'inherit',
  maxHeight = 'inherit',
}: VideoPlayerProps): ReactElement => {
  const [player, setPlayer] = useState<PlayerProps>(undefined!);

  // const {
  //   contentDetails: { video },
  // } = useContents();

  // useEffect(() => {
  //   console.log('deveria', player, startInSecond);
  //   if (player && startInSecond) {
  //     player.setCurrentTime(startInSecond);
  //     player.play();
  //   }
  // }, [startInSecond]);

  useEffect(() => {
    if (player) {
      if (startInSecond) {
        player.setCurrentTime(startInSecond);
      }

      player.setQuality('720p');
    }
  }, [player, startInSecond]);

  return (
    <Vimeo
      data-teste="vimeo-player"
      video={externalVideoProviderIdOrUrl}
      onReady={(currentPlayer: PlayerProps) => setPlayer(currentPlayer)}
      showTitle={false}
      speed
      quality="720p"
      volume={1}
      onTimeUpdate={(videoTime: any) => {
        if (onTimeUpdate) onTimeUpdate(videoTime.seconds);
      }}
      onEnd={(videoTime: any) => {
        if (onEnd) onEnd(videoTime.duration); // TODO: enviar valor total do video
      }}
      // start={startInSecond} // TODO: ajustar autoplay start in

      customWidth={width}
      customHeight={height}
      customMaxWidth={maxWidth}
      customMaxHeight={maxHeight}
    />
  );
};

export default VimeoPlayer;
